// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Sv-z","tooltipWrapper":"Tv-z","icon":"Uv-z","tooltip":"Vv-z","content":"Wv-z"};